import { StatusEnums } from "@typings/enums";

/** Helper function to get the status heading for subscribe page. */
export const getSubscribeStatusHeading = (status: StatusEnums): string => {
  switch (status) {
    case StatusEnums.Loading:
      return "Updating your subscriptions.";
    case StatusEnums.Success:
      return "Your subscriptions have been updated!";
    case StatusEnums.Error:
      return "I am sorry about that.";
  }
};

/** Helper function to get the status description for subscribe page. */
export const getSubscribeStatusDescription = (status: StatusEnums): string => {
  switch (status) {
    case StatusEnums.Loading:
      return "Please wait while we updated your newsletter subscriptions.";
    case StatusEnums.Success:
      return "You will start receiving your newsletters soon.";
    case StatusEnums.Error:
      return "There was an error updating your subscriptions. Please try again.";
  }
};
